import { useTranslation } from "react-i18next";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { modeConstants, translationConstants } from "../../../../constants";
import { boatType, genderAllowed, sportType } from "./utilities";
import { debounce } from "../../../../system";
import cancelIcon from "../../../../assets/images/icon/crossIcon.svg";
import {
  PlusIcon,
  SearchBoxIcon,
} from "../../../../assets/images/icon/iconsProvider";
const column = {
  sport: "sportId",
  boatType: "boatTypeId",
  gender: "genders.Contains",
  search: "search",
};

const FilterComponent = (props) => {
  const { setGridState, gridState, defaultQueryExpression } = props;
  const { t, i18n } = useTranslation();

  const [sportOptions, setSportOptions] = useState(sportType(t));
  const [boatTypeOptions, setBoatTypeOptions] = useState(boatType(t));
  const [genderOptions, setGenderOptions] = useState(genderAllowed(t));
  const [inputSearch, setInputSearch] = useState("");
  const [sportFilter, setSportFilter] = useState("");
  const [boatTypeFilter, setBoatTypeFilter] = useState("");
  const [genderFilter, setGenderFilter] = useState("");

  const searchInputRef = useRef(null);

  useEffect(() => {
    setSportOptions(sportType(t));
    setBoatTypeOptions(boatType(t));
    setGenderOptions(genderAllowed(t));
    // eslint-disable-next-line
  }, [i18n.dir()]);

  const buildFilterQuery = () => {
    let filterQueryExpression = defaultQueryExpression;

    if (sportFilter) {
      filterQueryExpression += `&& ${column.sport} == ${sportFilter} `;
    }

    if (boatTypeFilter) {
      filterQueryExpression += `&& ${column.boatType} == ${boatTypeFilter} `;
    }

    if (genderFilter) {
      filterQueryExpression += `&& ${column.gender}(${genderFilter}) `;
    }

    return filterQueryExpression;
  };

  useEffect(() => {
    const filterQueryExpression = buildFilterQuery();
    setGridState({
      ...gridState,
      filterQuery: filterQueryExpression,
      search: inputSearch,
    });
  }, [inputSearch, sportFilter, boatTypeFilter, genderFilter]);

  const onFilterChange = useCallback((key, value) => {
    switch (key) {
      case column.sport:
        setSportFilter(value);
        break;
      case column.boatType:
        setBoatTypeFilter(value);
        break;
      case column.gender:
        setGenderFilter(value);
        break;
      case column.search:
        setInputSearch(value);
        break;
      default:
        break;
    }
  }, []);

  const handleResetSearch = () => {
    searchInputRef.current.value = "";
    setInputSearch("");
  };

  const handleClearFilters = () => {
    setSportFilter("");
    setBoatTypeFilter("");
    setGenderFilter("");
    setGridState({
      ...gridState,
      filterQuery: defaultQueryExpression,
    });
  };

  const handleSearch = debounce((value) => {
    setInputSearch(value);
  }, process.env.REACT_APP_SEARCH_DEBOUNCE_INTERVAL);

  return (
    <Container className="m-0 p-0 mw-100 pb-2">
      <Row className="py-2">
        <Col
          md={3}
          xs={12}
          className="d-flex justify-content-sm-start justify-content-center py-2 px-2"
        >
          <div className="searchInputDiv gap-2 d-flex justify-content-between align-items-center w-100">
            <div>
              <SearchBoxIcon />
            </div>
            <input
              type="text"
              className="searchInput w-100"
              placeholder={t(translationConstants.Search)}
              onChange={(e) => handleSearch(e.target.value)}
              ref={searchInputRef}
            />
            {inputSearch && (
              <div onClick={handleResetSearch} className="cross cursor-pointer">
                <img width={16} src={cancelIcon} alt="cancel icon" />
              </div>
            )}
          </div>
        </Col>

        <Col xs={12} md={2} className="px-2 py-2">
          <Form.Select
            className="custom-select-icon filter-style"
            aria-label="Default select example"
            value={sportFilter}
            onChange={(event) =>
              onFilterChange(column.sport, event.target.value)
            }
          >
            <option value="">{t(translationConstants.sportType)}</option>
            {sportOptions?.map((option) => (
              <option
                className="capitalize-first"
                key={option.id}
                value={option.value}
              >
                {t(option.label)}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} md={2} className="px-2 py-2">
          <Form.Select
            className="custom-select-icon filter-style"
            aria-label="Default select example"
            value={boatTypeFilter}
            onChange={(event) =>
              onFilterChange(column.boatType, event.target.value)
            }
          >
            <option value="">{t(translationConstants.BOAT_TYPE)}</option>
            {boatTypeOptions.map((option) => (
              <option
                className="capitalize-first"
                key={option.id}
                value={option.value}
              >
                {t(option.label)}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} md={2} className="px-2 py-2">
          <Form.Select
            className="custom-select-icon filter-style"
            aria-label="Default select example"
            value={genderFilter}
            onChange={(event) =>
              onFilterChange(column.gender, event.target.value)
            }
          >
            <option value="">{t(translationConstants.gender)}</option>
            {genderOptions?.map((option) => (
              <option
                className="capitalize-first"
                key={option.id}
                value={option.value}
              >
                {t(option.label)}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} md={1} className="px-2 py-2">
          {(sportFilter || boatTypeFilter || genderFilter) && (
            <div className="cancel-filter" onClick={handleClearFilters}>
              {t(translationConstants.CLEAR_FILTERS)}
            </div>
          )}
        </Col>

        <Col className="d-flex justify-content-center justify-content-md-end align-items-center py-2">
          <Button
            className="Registeration-button m-0 "
            type="submit"
            onClick={() => {
              props?.setModalMode(modeConstants.ADD_MODE);
              props?.setShowModal((prev) => !prev);
            }}
          >
            <PlusIcon />
            &nbsp;
            {t(translationConstants.ADD_CLASS)}
          </Button>
        </Col>

        <Col
          xs={12}
          className="d-flex justify-content-center justify-content-sm-end align-items-center py-2"
        >
          {props.children}
        </Col>
      </Row>
    </Container>
  );
};

export default FilterComponent;
